export function pascalCaseToCamelCaseReviver(this: any, key: string, value: any): any {
    if (key === "" || !/^[A-Z]/.test(key)) {
        return value;
    }

    const processedKey = key.charAt(0).toLowerCase() + key.slice(1);
    this[processedKey] = value;
}
